import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { groupBy } from "@signals"
import { BACKEND_APIS } from "@constants"


export default function AppCommonFiltersGroupByAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		value={groupBy.value}
		onChange={e => groupBy.value = e.target.value}
		label="Group by option"
		placeholder="Group by"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/bi-group-options?service_type=bi`}
		{...props}
	/>
}